import { EditorPaasApi } from './editorPaasApi';
import { EditorAPIKey, EditorPaasApiKey } from '#packages/apis';
import { BaseEntryScope, createEntryPoint } from '#packages/apilib';

export class EditorPaasScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
}

export const EditorPaasApiEntryPoint = createEntryPoint({
  name: 'EditorPaasApi',
  Scope: EditorPaasScope,
  publicApi({ contributeApi }) {
    contributeApi(EditorPaasApiKey, EditorPaasApi);
  },
  initialize() {},
});
